<div class="container" id="servicemaindiv">
  <div class="header-row">
    <div class="button-group">
      <button mat-button (click)="openAddUpdateServiceModal()">Add Service</button>
    </div>
  </div>
  <div class="table-container">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>
          Service Name
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.name}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef>
          Description
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.description}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="associatedclients">
        <mat-header-cell *matHeaderCellDef>
          Associated Clients
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <button mat-button (click)="viewAssociatedClients(item)">View</button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
          Action
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div class="button-group action-buttons">
            <button mat-button (click)="openAddUpdateServiceModal(item)">Edit</button>
            <button mat-button (click)="openConfirmationDialog(item)">Delete</button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
  <!-- <mat-card id="servicecard">
    <mat-card-subtitle class="service-title">Add Service</mat-card-subtitle>
    <mat-card-content>        
        <div fxLayout="column">
            <mat-form-field id="serviceName">
                <mat-label>Service Name</mat-label>
                <input matInput [(ngModel)]="service.serviceName" name="serviceName" placeholder="Service Name" [value]="service.serviceName" required (mouseout)="validateNewForm()">              
            </mat-form-field>
            <mat-form-field id="serviceDescription" class="full-width">
                <mat-label>Service Description</mat-label>
                <textarea matInput placeholder="Service Description" [(ngModel)]="service.serviceDescription" rows="5" name="serviceDescription" [value]="service.serviceDescription" (mouseout)="validateNewForm()" required></textarea>
            </mat-form-field>

            <div style="margin-top: 24px;">
                <div style="color: red" *ngIf="hasError">{{errorMessage}}</div>
                <div fxFlex></div>
                <button  *ngIf="!hasError"  class="mat-small-button" mat-button (click)="changeUserAction('addService','')">Add</button>  
            </div>
            
        </div>

    </mat-card-content>
  </mat-card>

  <mat-card id="servicedetailcard" (mouseenter)="hasError=false">
    <mat-card-subtitle class="service-title">Update Service</mat-card-subtitle>
    <mat-card-content>
      <div fxLayout="row wrap" style="margin-top: -24px;">
        <div fxLayout="column" id="updatediv1">

            <mat-form-field id="selectservice" style="margin-top:24px;">
                <mat-label>Select Service to update</mat-label>
                <mat-select placeholder="Select Service" disableOptionCentering [(ngModel)]="selectedService" (selectionChange)="getAssignedServices()">               
                  <mat-option *ngFor="let svc of serviceList" [value]="svc">{{svc.serviceName}}</mat-option>                
                </mat-select>
            </mat-form-field>  

            <mat-form-field id="serviceNameselectedService">
              <mat-label>Service Name</mat-label>
              <input matInput [(ngModel)]="selectedService.serviceName" name="serviceNameselectedService" [value]="selectedService.serviceName" required>              
            </mat-form-field>
  
            <mat-form-field id="serviceDescriptionupdate" class="full-width">
              <mat-label>Service Description</mat-label>
              <textarea matInput [(ngModel)]="selectedService.serviceDescription" rows="5" name="serviceDescriptionupdate" [value]="selectedService.serviceDescription" required></textarea>
            </mat-form-field>

        </div>
      </div>
    </mat-card-content>
          

    <mat-card-actions style="margin-bottom: 24px;">
      <button [disabled]="!selectedService.serviceId" mat-button class="mat-small-button" (click)="changeUserAction('deleteService','');" [disabled]="inprogress">Delete</button>
      <div fxFlex></div>
      <button [disabled]="!selectedService.serviceId" mat-button class="mat-small-button" (click)="changeUserAction('updateService','');" [disabled]="inprogress">Update</button>
    </mat-card-actions>

    <mat-spinner *ngIf="inprogress" [diameter]="20"></mat-spinner>

  </mat-card>

  <mat-card id="servicedetailcard2" (mouseenter)="hasError=false" *ngIf="clientList.length > 0">
    <mat-card-subtitle class="service-title">Service Alias (Client's Service Name)</mat-card-subtitle>
    <mat-card-content>   
      <div>

        <mat-form-field id="selectservicealiasfieldclient">  
          <mat-label>Client</mat-label>         
          <mat-select [disabled]="!selectedService.serviceId" placeholder="Select Client" disableOptionCentering [(ngModel)]="selectedClient" (selectionChange)="getClientData()" placeholder="Client">               
            <mat-option *ngFor="let cl of clientList" [value]="cl">{{cl.clientId}}</mat-option>                
          </mat-select>
        </mat-form-field>

        <mat-form-field id="selectservicealiasfieldaliast">
            <mat-label>Service Alias</mat-label>
            <input matInput [(ngModel)]="clientServiceMap.serviceAlias" name="newServiceAliasservicename" [value]="clientServiceMap.serviceAlias" placeholder="Service Alias" required>              
        </mat-form-field>

        <button mat-button class="mat-small-button" (click)="changeUserAction('addtoList','');" [disabled]="!(clientServiceMap.clientId && clientServiceMap.serviceId)">
          Update
        </button>
      
      <table id="aliastable" style="width: 100%;">
        <tr class="subtitle-2 header-row">
          <td>Client</td>
          <td>Service Alias</td>
          <td>Action</td>
        </tr>       
        <tr *ngFor="let csMap of clientServiceMapList">
          <td>{{csMap.clientId}}</td>
          <td>{{csMap.serviceAlias}}</td>
          <td> 
              <button mat-button class="mat-small-button" (click)="changeUserAction('removefromList', csMap);" [disabled]="csMap.serviceAlias == selectedService.serviceName">
                Remove
              </button>   
          </td>
        </tr>
      </table>
    </div>
    </mat-card-content>    
    
  </mat-card> -->

  <!-- <div fxFlex.gt-md="10%" fxLayout="column"  id="actiondiv" >    
        <button mat-button class="mat-small-button" color="primary" id="addbutton" (click)="initializeValues(); userAction = 'addService'">Add Service</button>    
        <button mat-button class="mat-small-button" color="accent" id="updatebutton" (click)="initializeValues(); userAction = 'updateService'">Update Service</button>    
        <button mat-button class="mat-small-button" color="warn" id="deletebutton" (click)="initializeValues(); userAction = 'deleteService'">Delete Service</button>    
    </div>
  
    <div id="formdiv" >
      <form >
        <mat-card class=" shadow-1" fxLayout="column" fxLayoutAlign="start center">
          <mat-card-title class="subtitle-1">
            <span *ngIf="userAction == 'addService'">Add New Service</span>
            <span *ngIf="userAction == 'updateService'">Update Service</span>
            <span *ngIf="userAction == 'deleteService'">Delete Service</span>
          </mat-card-title>
  
          <mat-card-content>            
              <mat-form-field id="clientId" hintLabel="Client Code" style="margin-right:12px;">                
                <mat-select placeholder="Select Client" disableOptionCentering (selectionChange)="getClientData($event.value)" >               
                  <mat-option *ngFor="let cl of clientList" [value]="cl['clientId']">{{cl['clientId']}}</mat-option>                
                </mat-select>
              </mat-form-field>
  
              <mat-form-field id="serviceName" hintLabel="Service Name" style="margin-left:12px;">
                 <input matInput  *ngIf="userAction == 'addService'" [(ngModel)]="service.serviceName" name="serviceName" placeholder="Service Name" [value]="service.serviceName" required>
                 <mat-select *ngIf="userAction != 'addService'" [(ngModel)]="service.serviceName" name="serviceName" placeholder="Select Service" disableOptionCentering (selectionChange)="getServiceData($event.value)" >               
                    <mat-option *ngFor="let slt of serviceList" [value]="slt.serviceName">{{slt.serviceName}}</mat-option>                
                  </mat-select>
              </mat-form-field>
  
              <p>
                <mat-form-field id="serviceDescription" class="full-width" hintLabel="Service Description">
                  <textarea matInput placeholder="Service Description" [(ngModel)]="service.serviceDescription" rows="5" name="serviceDescription" [value]="service.serviceDescription" required></textarea>
                </mat-form-field> 
                
                <mat-form-field id="serviceStatus" hintLabel="Current Status">                
                  <mat-select name="serviceStatus" [(ngModel)]="service.serviceStatus" placeholder="Current Status" disableOptionCentering (selectionChange)="setServiceStatus($event.value)" >               
                    <mat-option *ngFor="let sl of serviceStatusList" [value]="sl" >{{sl}}</mat-option>                
                  </mat-select>
                </mat-form-field>
  
              </p>
  
              <p *ngIf="hasError" class="haserror">{{errorMessage}}</p>
              <p *ngIf="hasSuccess" class="hassuccess">Success {{userAction == 'addService'? 'Adding' : userAction == 'updateService'?'Updating': 'Deleting'}} service {{service.serviceName}}</p>
              <p *ngIf="inprogress" clas="spinner"><mat-spinner diameter="15" ></mat-spinner> </p>
              
              <button mat-button class="mat-large-button full-width"  color="primary" (click)="validateForm()" >{{userAction == 'addService'? 'Add ' : userAction == 'updateService'?'Update ' : 'Delete '}}Service</button>
  
  
          </mat-card-content>
        </mat-card>
      </form>
    </div> -->

</div>